import React, { useRef } from "react";
import Dropdown, { DropdownProps } from "./Dropdown";
import TextInput from "./InputField/TextInput";
import useGetProductList from "hooks/inventoryHooks/useGetProductList";
import clsx from "clsx";

type ProductSelectInputProps = { required?: boolean } & DropdownProps;

export default function ProductSelectInput(props: ProductSelectInputProps) {
    const { value, handleChange, required, ...rest } = props;
    const clearSearchRef = useRef(null);

    const {
        productSearchList,
        handleDebouncedChangeTwo,
        handleSearchTwo,
        searchTwo,
        isLoadingMore,
        isFetchingSecondList,
        isFetching,
    } = useGetProductList(null, "Finished Goods", false, false, "", false);

    const productValueId = value?.split("-")[0];
    const productValueName = value?.split("-")[1] || "";
    const isLoading = isLoadingMore || isFetchingSecondList || isFetching;

    return (
        <Dropdown
            dropdown={
                <div className="flex relative items-center rounded-[6px] justify-between w-full h-[50px] px-[6px] !text-[#94A3B8]  !border !border-[#D0D4D7]">
                    <div
                        className={clsx(
                            `text-g-75 truncate px-[10px] py-[14px] text-[11px] xs:text-[13px]`,
                            !!productValueName ? "!text-slate-700" : "!text-[#94A3B8]"
                        )}
                    >
                        {productValueName ? productValueName : "Select new product"}
                        {required && <span className="required !text-r-50">*</span>}
                    </div>
                    <div className="flex-1" />
                    <i className="ri-arrow-down-s-line text-xs xs:text-lg text-g-75 !text-[#94A3B8]"></i>
                </div>
            }
            dropdownItemsClasses="!px-0 !py-0  !w-full"
            dropdownClassName="!mb-10 !-mt-7 !w-full"
            dropdownContainerClasses="border border-[#D0D4D7] !left-0 rounded-[6px] !bottom-[0px] !min-h-[300px] !max-h-[300px] !w-[30px] !pt-0"
            loader={isLoading}
            wholeContainerClass="!w-full"
            search={
                <div ref={clearSearchRef} className="">
                    <TextInput
                        value={searchTwo}
                        name={"search"}
                        type={"text"}
                        required={false}
                        onChange={handleSearchTwo}
                        onInput={handleDebouncedChangeTwo}
                        inputPlaceholder="Search product"
                        containerClassname=""
                        inputContainerClassname="!h-[50px]"
                    />
                </div>
            }
            handleChange={(_, value) => {
                handleChange?.(_, value);
                handleSearchTwo({
                    target: {
                        value: "",
                    },
                } as React.ChangeEvent<HTMLInputElement>);
                handleDebouncedChangeTwo({
                    target: {
                        value: "",
                    },
                } as React.ChangeEvent<HTMLInputElement>);
            }}
            dropdownOptions={
                isLoading
                    ? [
                          {
                              label: "",
                              value: "",
                          },
                      ]
                    : productSearchList?.length > 0
                    ? [
                          ...productSearchList
                              ?.filter((item) => item?.inventoryCategory === "Finished Goods")
                              ?.map((item, idx) => ({
                                  label: (
                                      <div
                                          key={idx}
                                          className={clsx(
                                              "text-slate-600 text-[13px] gap-2 border-b border-b-slate-100 !w-full !max-w-[150px] md:!max-w-[300px] !mx-auto px-2 py-[10px]",
                                              productValueId === item?._id &&
                                                  "bg-slate-100 !text-slate-900"
                                          )}
                                      >
                                          <div className="flex gap-2 items-center !w-full">
                                              <div className="">
                                                  {item?.productImageDetails?.productAvatar ? (
                                                      <div className=" ">
                                                          <img
                                                              src={
                                                                  item?.productImageDetails
                                                                      ?.productAvatar
                                                              }
                                                              className="h-8 w-8 rounded"
                                                              alt="product-image"
                                                          />
                                                      </div>
                                                  ) : (
                                                      <div className="w-8 h-8 rounded flex items-center justify-center bg-slate-200 ">
                                                          <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                                      </div>
                                                  )}
                                              </div>
                                              <p className="font-rocGroteskMedium truncate">
                                                  {item?.productName}
                                              </p>
                                          </div>
                                      </div>
                                  ),
                                  value: item?._id + "-" + item?.productName,
                              })),
                      ]
                    : [
                          {
                              label: (
                                  <div className="flex items-center justify-center gap-2 px-4">
                                      <p className="text-slate-500 text-center">No product found</p>
                                  </div>
                              ),
                              value: "",
                          },
                      ]
            }
            {...rest}
        />
    );
}
